const responseHandleErrorLogic = async (error, app) => {  
  let { message } = error;
  const { type } = error.response.data;
  if (error.response && error.response.data) {
    if (['VALIDATION_ERROR', 'DETAIL_ERROR_ARRAY', 'ASN_VALIDATION_ERROR'].includes(type)) {
      const locale = app.$i18n.locale || 'en';
      const translate = type === 'VALIDATION_ERROR' || type === 'ASN_VALIDATION_ERROR'
        ? app.$i18n.t.bind(app.$i18n)
        : (t, v) => v.message;

      error.translatedErrorList = (error.response.data.data || []).map((item) => ({
        [locale]: translate('validation.validation_error_at_field', item),
      }));
      if (type === 'VALIDATION_ERROR') {
        app.$toast(error.translatedErrorList[0][locale], {
          title: app.$t('toast.danger'),
          variant: 'danger',
        });
      }

      if (type === 'ASN_VALIDATION_ERROR'){
        const toKey = (type) => `asn_errors.${type}`
        error.translatedErrorList = (error.response.data.data || []).map((item) => ({
          [locale]: translate(toKey(item.type),  item.data),
        }));
      }

      // We should handle this type separately
      return Promise.reject(error);
    }
  }

  if (error.response.data && error.response.data.message) {
    message = error.response.data.message;
  } else if (error.request.responseType === 'blob'
    && error.response.data
    && error.response.data.type === 'application/json') {
    let blobError;
    try {
      const resText = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsText(error.response.data);
      });

      blobError = JSON.parse(resText);
    } finally {
      if (blobError && blobError.message) {
        message = blobError.message;
      }
    }
    if (blobError && blobError.type === 'NO_PACKING_LIST_DATA') {
      return Promise.resolve();
    }
  }

  app.$toast(message, {
    title: app.$t('toast.danger'),
    variant: 'danger',
  });

  return Promise.resolve();
};

export default responseHandleErrorLogic;
